import React, { useState, useEffect, useCallback } from "react";
import "../../../css/common.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import { faSquare as farSquare } from '@fortawesome/free-regular-svg-icons';

const BasicTable = ({
  headers = [],
  rows = [],
  checkbox = false,
  onSelectionChange = () => {},
  selectedRows,
  disabledRowsIds = [],
}) => {
  const [initialized, setInitialized] = useState(false);

  const setSelectedRows = useCallback(
    (newSelectedRows) => {
      onSelectionChange(newSelectedRows);
    },
    [onSelectionChange]
  );

  useEffect(() => {
    if (!initialized && rows.length > 0 && selectedRows === null) {
      const allRows = rows.map((row) => row?.id);
      setSelectedRows(allRows); // Initialize selected rows with all row IDs
      setInitialized(true);
    }
  }, [initialized, rows, selectedRows, setSelectedRows]);

  // Handle checkbox change
  const handleCheckboxChange = (row) => {
    let updatedSelectedRows;

    if (selectedRows.includes(row.id)) {
      // Remove the row if it's already selected
      updatedSelectedRows = selectedRows.filter((id) => id !== row.id);
    } else {
      // Add the row if it's not selected
      updatedSelectedRows = [...selectedRows, row.id];
    }

    setSelectedRows(updatedSelectedRows);
  };

  // Check if all rows are selected
  const allSelected = selectedRows && selectedRows.length === rows.length;

  // Handle "Select All" checkbox
  const handleSelectAll = () => {
    if (allSelected) {
      if (disabledRowsIds.length > 0) {
        setSelectedRows(disabledRowsIds); 
        return;
      }
      setSelectedRows([]); // Deselect all
    } else {
      const allRowIds = rows.map((row) => row.id);
      setSelectedRows(allRowIds); // Select all
    }
  };

  const renderRow = (row, index) => {
    if (typeof row !== "object" || row === null) {
      return;
    }
    return (
      <>
        {Object.keys(row).map((key, index) => {
          if (key !== "id") {
            return <div key={index} className="basic-data-table-row-item basic-data-table-border">{row[key]}</div>; // Exclude `id` from data
          }
          return null;
        })}
      </>
    );
  };

  return (
    <div className="basic-data-table-container">
      {selectedRows && <div
        className="basic-data-table-header"
        style={{
          gridTemplateColumns: `100px repeat(${headers.length}, 1fr)`,
          gridTemplateRows: `45px`,
        }}
      >
        <div key="checkbox-all" className="basic-data-table-checkbox basic-data-table-border">
          <div className="basic-data-table-checkbox-cell" onClick={handleSelectAll}>
            <FontAwesomeIcon icon={allSelected ? faMinusSquare : farSquare}/>
          </div>
        </div>
        {headers.map((header, index) => (
          <div key={header} className="basic-data-table-header-item basic-data-table-border">
            {header}
          </div>
        ))}
      </div>}

      {selectedRows && <div
        className="basic-data-table-rows"
        style={{
          display: "grid",
          gridTemplateRows: `repeat(${rows.length}, minmax(40px, auto))`
        }}
      >
        {rows.map((row, index) => (
          <div key={row.id + Math.random()} className="basic-data-table-row" style={{
          gridTemplateColumns: `100px repeat(${headers.length}, 1fr)`,
        }}>
          {checkbox && row?.id && (
            <div key={index} className="basic-data-table-checkbox basic-data-table-border">
              <div className="basic-data-table-checkbox-cell" onClick={disabledRowsIds.includes(row.id) ? null : () => handleCheckboxChange(row)}
                style={disabledRowsIds.includes(row.id) ? {
                  cursor: 'not-allowed',
                } : {}}
              >
                <FontAwesomeIcon className={disabledRowsIds.includes(row.id) ? 'dark-gray-text' : selectedRows.includes(row.id) ? 'blue-text' : 'dark-gray-text'} icon={selectedRows.includes(row.id) ? faCheckSquare : farSquare}/>
              </div>
            </div>
          )}
          {renderRow(row, index)}
          </div>
        ))}
      </div>}
    </div>
  );
};

export default BasicTable;
